import AbstractValue from '@/models/app-config/behavior/abstract-value'

export interface RawItem {
  price: RawItemPrice
}

interface RawItemPrice {
  onlyShowPriceWithTax: boolean
}

export class Item extends AbstractValue<RawItem> {
  get price(): ItemPrice {
    return new ItemPrice(this.raw.price)
  }
}

class ItemPrice extends AbstractValue<RawItemPrice> {
  get onlyShowPriceWithTax(): boolean {
    return this.raw.onlyShowPriceWithTax || false
  }
}
